import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c482ff1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column justify-content-between h-100" }
const _hoisted_2 = { class: "row row-name mb-2" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "row row-content mb-3" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "wrapper bg-light rounded p-3" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "d-flex align-items-center fs-3 mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "contextual_token", -1))
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "bg-white rounded p-3 mb-3" }
const _hoisted_16 = { class: "table table-hover table-v2 mb-0" }
const _hoisted_17 = { class: "d-flex align-items-center justify-content-between lh-1 fs-5 mb-0" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "article", -1))
const _hoisted_20 = { class: "d-flex justify-content-end align-items-center pe-0" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "bg-white rounded p-3" }
const _hoisted_25 = { class: "d-flex align-items-center justify-content-between lh-1 fs-5 mb-3 ps-0" }
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "check_box", -1))
const _hoisted_28 = { class: "border border-1 p-2" }
const _hoisted_29 = {
  key: 0,
  class: "d-flex align-items-top gap-2 ms-4"
}
const _hoisted_30 = { class: "align-middle mt-2" }
const _hoisted_31 = { class: "mt-n2" }
const _hoisted_32 = { class: "col-6" }
const _hoisted_33 = { class: "wrapper bg-light rounded p-3" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-4" }
const _hoisted_36 = { class: "d-flex align-items-center fs-3 mb-3" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "mobile_layout", -1))
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-12 mb-3 mb-xl-0" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-12" }
const _hoisted_42 = { class: "bg-white rounded p-3 pb-0" }
const _hoisted_43 = { class: "p-2" }
const _hoisted_44 = { class: "row mb-2" }
const _hoisted_45 = { class: "col-12" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-12" }
const _hoisted_48 = { class: "row row-settings mb-3" }
const _hoisted_49 = { class: "col-12" }
const _hoisted_50 = { class: "wrapper bg-light rounded p-3" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-12" }
const _hoisted_53 = { class: "d-flex align-items-center fs-3 mb-3" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-2" }, "settings", -1))
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-6 col-associations-visibility-rules" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-12" }
const _hoisted_59 = { class: "bg-white rounded p-3 mb-3" }
const _hoisted_60 = { class: "table table-hover table-v2 mb-0" }
const _hoisted_61 = { class: "d-flex align-items-center justify-content-between lh-1 fs-5 ps-0" }
const _hoisted_62 = { class: "d-flex align-items-center" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "pages", -1))
const _hoisted_64 = { class: "d-flex justify-content-end align-items-center pe-0" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1))
const _hoisted_66 = { class: "border border-1 p-2" }
const _hoisted_67 = {
  key: 0,
  class: "d-flex col-12"
}
const _hoisted_68 = { class: "text-muted mb-0" }
const _hoisted_69 = {
  key: 1,
  class: "table table-hover table-v2 mb-0"
}
const _hoisted_70 = { class: "d-flex justify-content-end align-items-center pe-0" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_72 = ["onClick", "data-dp-tooltip"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete", -1))
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = { class: "row" }
const _hoisted_76 = { class: "col-12" }
const _hoisted_77 = { class: "bg-white rounded p-3" }
const _hoisted_78 = { class: "table table-hover table-v2 mb-0" }
const _hoisted_79 = { class: "d-flex align-items-center justify-content-between lh-1 fs-5 ps-0" }
const _hoisted_80 = { class: "d-flex align-items-center" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "visibility", -1))
const _hoisted_82 = { class: "d-flex justify-content-end align-items-center pe-0" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1))
const _hoisted_84 = { class: "border border-1 p-2" }
const _hoisted_85 = {
  key: 0,
  class: "d-flex col-12"
}
const _hoisted_86 = { class: "text-muted mb-0" }
const _hoisted_87 = {
  key: 1,
  class: "table table-hover table-v2 mb-0"
}
const _hoisted_88 = { class: "d-flex justify-content-end align-items-center pe-0" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_90 = ["onClick", "data-dp-tooltip"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete", -1))
const _hoisted_92 = [
  _hoisted_91
]
const _hoisted_93 = { class: "col-6 col-triggers mb-3" }
const _hoisted_94 = { class: "row" }
const _hoisted_95 = { class: "col-12" }
const _hoisted_96 = { class: "bg-white rounded p-3" }
const _hoisted_97 = { class: "table table-hover table-v2 mb-0" }
const _hoisted_98 = { class: "d-flex align-items-center justify-content-between lh-1 fs-5 ps-0" }
const _hoisted_99 = { class: "d-flex align-items-center" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "touch_triple", -1))
const _hoisted_101 = { class: "d-flex justify-content-end align-items-center pe-0" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1))
const _hoisted_103 = { class: "border border-1 p-2" }
const _hoisted_104 = {
  key: 0,
  class: "d-flex col-12"
}
const _hoisted_105 = { class: "text-muted mb-0" }
const _hoisted_106 = {
  key: 1,
  class: "table table-hover table-v2 mb-0"
}
const _hoisted_107 = { class: "d-flex justify-content-end align-items-center pe-0" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_109 = ["onClick", "data-dp-tooltip"]
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "delete", -1))
const _hoisted_111 = [
  _hoisted_110
]
const _hoisted_112 = { class: "d-flex flex-column" }
const _hoisted_113 = { class: "col-3" }
const _hoisted_114 = { class: "row align-items-center pt-3 border-top border-1 border-black border-opacity-25" }
const _hoisted_115 = { class: "col-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputCheckboxMultiSelect = _resolveComponent("InputCheckboxMultiSelect")!
  const _component_input_number = _resolveComponent("input-number")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_base_offcanvas_button_open = _resolveComponent("base-offcanvas-button-open")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_Trigger = _resolveComponent("Trigger")!
  const _component_base_offcanvas = _resolveComponent("base-offcanvas")!
  const _component_VisibilityRuleWrapper = _resolveComponent("VisibilityRuleWrapper")!
  const _component_Association = _resolveComponent("Association")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.pageUI.getError()
    }, null, 8, ["error"]),
    (!_ctx.pageUI.getIsReady())
      ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.pageUI.getIsReady() && _ctx.popup)
        ? (_openBlock(), _createBlock(_component_dp_form, {
            key: 0,
            as: "form",
            onSubmit: _ctx.submitData,
            novalidate: ""
          }, {
            default: _withCtx(({ errors }) => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.popup.popup.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.popup.popup.name) = $event)),
                    modelModifiers: { trim: true },
                    label: _ctx.$t('name'),
                    name: "name",
                    rules: "required|max:100",
                    errors: errors
                  }, null, 8, ["modelValue", "label", "errors"])
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("h2", _hoisted_9, [
                          _hoisted_10,
                          _createTextVNode(_toDisplayString(_ctx.$t('content')), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("section", _hoisted_15, [
                              _createElementVNode("table", _hoisted_16, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.I18nContext.getLanguages(), (language) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: language }, [
                                    _createElementVNode("td", null, [
                                      _createElementVNode("h3", _hoisted_17, [
                                        _createElementVNode("span", _hoisted_18, [
                                          _hoisted_19,
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('message')) + " (" + _toDisplayString(language.toUpperCase()) + ")", 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("button", {
                                          class: "btn btn-icon btn-primary align-self-end",
                                          type: "button",
                                          onClick: ($event: any) => (_ctx.openContent(language))
                                        }, _hoisted_23, 8, _hoisted_21)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("section", _hoisted_24, [
                              _createElementVNode("h3", _hoisted_25, [
                                _createElementVNode("span", _hoisted_26, [
                                  _hoisted_27,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('buttons')), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popupButtonOptions, (buttonType) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: buttonType.code
                                  }, [
                                    _createVNode(_component_InputCheckboxMultiSelect, {
                                      modelValue: _ctx.popup.popup.buttons,
                                      "onUpdate:modelValue": [
                                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.popup.popup.buttons) = $event)),
                                        _ctx.onPopupChanged
                                      ],
                                      label: buttonType.description,
                                      value: buttonType.code,
                                      name: "buttonTypes",
                                      errors: errors,
                                      onChange: _ctx.buttonChanged
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "value", "errors", "onChange"]),
                                    (buttonType.code === _ctx.PopupButtonEnum.DO_NOT_SHOW_AGAIN)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                          _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('for')), 1),
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_input_number, {
                                              modelValue: _ctx.popup.popup.do_not_show_duration_in_sec,
                                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.popup.popup.do_not_show_duration_in_sec) = $event)),
                                              name: "doNotShowDuration",
                                              errors: errors,
                                              mode: "group-end",
                                              addonText: _ctx.$t('sec'),
                                              class: "w-70",
                                              disabled: !_ctx.popup.popup.buttons.includes(_ctx.PopupButtonEnum.DO_NOT_SHOW_AGAIN)
                                            }, null, 8, ["modelValue", "errors", "addonText", "disabled"]),
                                            _createElementVNode("div", _hoisted_31, [
                                              _createElementVNode("span", {
                                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.popup.popup.do_not_show_duration_in_sec = 60 * 60 * 24)),
                                                class: "text-primary text-decoration-underline",
                                                style: {"cursor":"pointer"}
                                              }, _toDisplayString(_ctx.$t('1d')), 1),
                                              _createTextVNode("  "),
                                              _createElementVNode("span", {
                                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.popup.popup.do_not_show_duration_in_sec = 60 * 60 * 24 * 7)),
                                                class: "text-primary text-decoration-underline",
                                                style: {"cursor":"pointer"}
                                              }, _toDisplayString(_ctx.$t('7d')), 1),
                                              _createTextVNode("  "),
                                              _createElementVNode("span", {
                                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.popup.popup.do_not_show_duration_in_sec = 60 * 60 * 24 * 30)),
                                                class: "text-primary text-decoration-underline",
                                                style: {"cursor":"pointer"}
                                              }, _toDisplayString(_ctx.$t('1mth')), 1),
                                              _createTextVNode("  "),
                                              _createElementVNode("span", {
                                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.popup.popup.do_not_show_duration_in_sec = 60 * 60 * 24 * 90)),
                                                class: "text-primary text-decoration-underline",
                                                style: {"cursor":"pointer"}
                                              }, _toDisplayString(_ctx.$t('3mth')), 1)
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("h2", _hoisted_36, [
                          _hoisted_37,
                          _createTextVNode(_toDisplayString(_ctx.$t('layout')), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("section", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _createVNode(_component_input_select, {
                                      modelValue: _ctx.popup.popup.size_code,
                                      "onUpdate:modelValue": [
                                        _cache[7] || (_cache[7] = ($event: any) => ((_ctx.popup.popup.size_code) = $event)),
                                        _ctx.onPopupChanged
                                      ],
                                      label: _ctx.$t('size'),
                                      name: _ctx.$t('size'),
                                      options: _ctx.popupSizeOptions,
                                      rules: "required",
                                      errors: errors
                                    }, null, 8, ["modelValue", "label", "name", "options", "errors", "onUpdate:modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _createVNode(_component_input_select, {
                                      modelValue: _ctx.popup.popup.vertical_position_code,
                                      "onUpdate:modelValue": [
                                        _cache[8] || (_cache[8] = ($event: any) => ((_ctx.popup.popup.vertical_position_code) = $event)),
                                        _ctx.onPopupChanged
                                      ],
                                      label: _ctx.$t('verticalPosition'),
                                      name: _ctx.$t('verticalPosition'),
                                      options: _ctx.popupVerticalPositionOptions,
                                      rules: "required",
                                      errors: errors
                                    }, null, 8, ["modelValue", "label", "name", "options", "errors", "onUpdate:modelValue"])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("h2", _hoisted_53, [
                          _hoisted_54,
                          _createTextVNode(_toDisplayString(_ctx.$t('settings')), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("section", _hoisted_59, [
                              _createElementVNode("table", _hoisted_60, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", null, [
                                    _createElementVNode("h3", _hoisted_61, [
                                      _createElementVNode("span", _hoisted_62, [
                                        _hoisted_63,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('showOn')), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_64, [
                                      _createVNode(_component_base_offcanvas_button_open, {
                                        "offcanvas-id": "offcanvas-association",
                                        class: "btn btn-hover icon-link text-uppercase align-self-end",
                                        onBeforeOpen: _ctx.prepareOffCanvasForNewAssociation
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_65,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["onBeforeOpen"])
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_66, [
                                (!_ctx.associations?.results?.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                      _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.$t('noResults')), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("table", _hoisted_69, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associations.results, (association) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: association.id
                                        }, [
                                          _createElementVNode("td", null, _toDisplayString(_ctx.getAssociationDescription(association)), 1),
                                          _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_70, [
                                              (association.type.code !== _ctx.PopupAssociationTypeEnum.NAMED_PAGE
                                      && association.type.code !== _ctx.PopupAssociationTypeEnum.ALL_PAGES)
                                                ? (_openBlock(), _createBlock(_component_base_offcanvas_button_open, {
                                                    key: 0,
                                                    "offcanvas-id": "offcanvas-association",
                                                    class: "btn btn-icon btn-primary align-self-end",
                                                    onBeforeOpen: ($event: any) => (_ctx.prepareOffCanvasForEditAssociation(association))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_71
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onBeforeOpen"]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("button", {
                                                type: "button",
                                                onClick: ($event: any) => (_ctx.deleteAssociation(association)),
                                                class: "btn btn-icon btn-danger ms-2",
                                                "data-dp-tooltip": _ctx.$t('delete'),
                                                "data-dp-position": "left"
                                              }, _hoisted_74, 8, _hoisted_72)
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("section", _hoisted_77, [
                              _createElementVNode("table", _hoisted_78, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", null, [
                                    _createElementVNode("h3", _hoisted_79, [
                                      _createElementVNode("span", _hoisted_80, [
                                        _hoisted_81,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('visibilityRules')), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_82, [
                                      _createVNode(_component_base_offcanvas_button_open, {
                                        "offcanvas-id": "offcanvas-visibility-rule",
                                        class: "btn btn-hover icon-link text-uppercase align-self-end",
                                        onBeforeOpen: _ctx.prepareOffCanvasForNewVisibilityRule
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_83,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["onBeforeOpen"])
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_84, [
                                (!_ctx.visibilityRules?.results?.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                      _createElementVNode("p", _hoisted_86, _toDisplayString(_ctx.$t('noVisibilityRules')), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("table", _hoisted_87, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibilityRules.results, (visibilityRule) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: visibilityRule.id
                                        }, [
                                          _createElementVNode("td", null, _toDisplayString(visibilityRule.type.description
                                + (visibilityRule.description ? ' (' + _ctx.truncateString(visibilityRule.description) + ')' : '')), 1),
                                          _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_88, [
                                              _createVNode(_component_base_offcanvas_button_open, {
                                                "offcanvas-id": "offcanvas-visibility-rule",
                                                class: "btn btn-icon btn-primary align-self-end",
                                                onBeforeOpen: ($event: any) => (_ctx.prepareOffCanvasForEditVisibilityRule(visibilityRule))
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_89
                                                ]),
                                                _: 2
                                              }, 1032, ["onBeforeOpen"]),
                                              _createElementVNode("button", {
                                                type: "button",
                                                onClick: ($event: any) => (_ctx.deleteVisibilityRule(visibilityRule)),
                                                class: "btn btn-icon btn-danger ms-2",
                                                "data-dp-tooltip": _ctx.$t('delete'),
                                                "data-dp-position": "left"
                                              }, _hoisted_92, 8, _hoisted_90)
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_93, [
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("div", _hoisted_95, [
                            _createElementVNode("section", _hoisted_96, [
                              _createElementVNode("table", _hoisted_97, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", null, [
                                    _createElementVNode("h3", _hoisted_98, [
                                      _createElementVNode("span", _hoisted_99, [
                                        _hoisted_100,
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('triggers')), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_101, [
                                      _createVNode(_component_base_offcanvas_button_open, {
                                        "offcanvas-id": "offcanvas-trigger",
                                        class: "btn btn-hover icon-link text-uppercase align-self-end",
                                        onBeforeOpen: _ctx.prepareOffCanvasForNewTrigger
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_102,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["onBeforeOpen"])
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_103, [
                                (!_ctx.triggers?.results?.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                      _createElementVNode("p", _hoisted_105, _toDisplayString(_ctx.$t('noTriggers')), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("table", _hoisted_106, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.triggers.results, (trigger) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: trigger.id
                                        }, [
                                          _createElementVNode("td", null, _toDisplayString(trigger.type.description
                                + (trigger.description ? ' (' + _ctx.truncateString(trigger.description) + ')' : '')), 1),
                                          _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_107, [
                                              (trigger.type.code !== _ctx.PopupTriggerTypeEnum.EXIT_INTENT_TRIGGER)
                                                ? (_openBlock(), _createBlock(_component_base_offcanvas_button_open, {
                                                    key: 0,
                                                    "offcanvas-id": "offcanvas-trigger",
                                                    class: "btn btn-icon btn-primary align-self-end",
                                                    onBeforeOpen: ($event: any) => (_ctx.prepareOffCanvasForEditTrigger(trigger))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_108
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onBeforeOpen"]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("button", {
                                                type: "button",
                                                onClick: ($event: any) => (_ctx.deleteTrigger(trigger)),
                                                class: "btn btn-icon btn-danger ms-2",
                                                "data-dp-tooltip": _ctx.$t('delete'),
                                                "data-dp-position": "left"
                                              }, _hoisted_111, 8, _hoisted_109)
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_112, [
                _createElementVNode("div", _hoisted_113, [
                  _createVNode(_component_input_select, {
                    name: "cbStatus",
                    class: "fw-bold",
                    selectText: _ctx.$t('selectText'),
                    modelValue: _ctx.popup.popup.status_code,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.popup.popup.status_code) = $event)),
                    options: [{code: 'PUBLISHED', description: _ctx.$t('published'),},{code: 'NOT_PUBLISHED', description: _ctx.$t('notPublished'),},],
                    errors: errors
                  }, null, 8, ["selectText", "modelValue", "options", "errors"])
                ]),
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("button", {
                      onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitData && _ctx.submitData(...args)), ["prevent"])),
                      class: "btn btn-primary"
                    }, _toDisplayString(_ctx.$t('save')), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"]))
        : _createCommentVNode("", true),
      _createVNode(_component_base_offcanvas, {
        title: _ctx.$t('trigger'),
        id: "offcanvas-trigger",
        class: "offcanvas-wider"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_Trigger, {
            key: _ctx.triggerSequence,
            "popup-id": _ctx.id,
            id: _ctx.triggerId,
            triggerType: _ctx.triggerType,
            mode: _ctx.triggerMode,
            onEdit: _ctx.reloadContent
          }, null, 8, ["popup-id", "id", "triggerType", "mode", "onEdit"]))
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_component_base_offcanvas, {
        title: _ctx.$t('visibilityRule'),
        id: "offcanvas-visibility-rule",
        class: "offcanvas-wider"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_VisibilityRuleWrapper, {
            key: _ctx.visibilityRuleSequence,
            "popup-id": _ctx.id,
            id: _ctx.visibilityRuleId,
            mode: _ctx.triggerMode,
            "visibility-rule-options-keys": [_ctx.VisibilityRuleTypeEnum.VISIBLE_WITHIN_PERIOD, _ctx.VisibilityRuleTypeEnum.HIDE_WHEN_NOT_LOGGED_IN],
            onEdit: _ctx.reloadContent
          }, null, 8, ["popup-id", "id", "mode", "visibility-rule-options-keys", "onEdit"]))
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_component_base_offcanvas, {
        title: _ctx.$t('showOn'),
        id: "offcanvas-association",
        class: "offcanvas-wider"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_Association, {
            key: _ctx.associationSequence,
            "popup-id": _ctx.id,
            id: _ctx.associationId,
            mode: _ctx.associationMode,
            onEdit: _ctx.reloadContent
          }, null, 8, ["popup-id", "id", "mode", "onEdit"]))
        ]),
        _: 1
      }, 8, ["title"])
    ])
  ], 64))
}